import React from 'react'
import {FcAssistant} from "react-icons/fc"

export default function Heading() {
    return (
        <div className="heading">
            <h1><FcAssistant/>Emoji meanings</h1>
        </div>
    )
}
